import { createStore } from "vuex";
import {UserModule} from './module/UserModule'
import {RoleModule} from './module/RoleModule'
import {HomeModule} from './module/HomeModule'
import {StarredModule} from './module/StarredModule'
import {SharedWithMeModule} from './module/SharedWithMeModule'
import {TrashModule} from './module/TrashModule'
export default createStore({
    state: getDefaultRootState(),
    mutations: {
        resetRootState(state) {
          Object.assign(state, getDefaultRootState());
        }
    },
    modules: {
        home: HomeModule,
        user: UserModule,
        role: RoleModule,
        starred: StarredModule,
        sharedWithMe: SharedWithMeModule,
        trash: TrashModule,
    }
})



function getDefaultRootState() {
    return {
      pageTitle: 'Dashboard',
      stausOptions: [{ id: 2, text: 'All' }, { id: true, text: 'Active' }, { id: false, text: 'Inactive' }],
      stausShareOptions: [{ id: 1, text: 'Editor' }, { id: 2, text: 'View' }],
      stausShareEditOptions: [{ id: 1, text: 'Editor' }, { id: 2, text: 'View' }, { id: 3, text: 'Remove Access' }],
      fileNameParam: '',
      fileNameIdParam: '',
      fullOldKey: '',
      isLogin: 1,
      tableFolderLoad: 1,
      showEntries: 15,
      pageSize: 6,
      pageShimmerSize: 6,
      folderList: [],
      folderSubList: [],
      isSubFolder: 1,
      isDarkMode: false,
      sharedWith: [],
      accessUsers: [],
      ownerData:[],
      selectedAccessTypes:{},
      currentPageSlug: '',
      isModalImgOpen: 1,
    };
  }